import { inject, Injectable } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { Functions, httpsCallable } from "@angular/fire/functions";
import { BehaviorSubject } from "rxjs";
import { IActivation } from "src/app/activation/activation.interface";
import { ALERT_TYPE, AlertService } from "./alert.service";

@Injectable({ providedIn: "root" })
export class ActivationService {
  /** determina a expansao do modal de ativacao */
  expandModal = new BehaviorSubject(false);
  private firestore = inject(Firestore);
  private aff = inject(Functions);
  private alertService = inject(AlertService);

  async activateCard(data: IActivation): Promise<any> {
    try {
      const req = httpsCallable(this.aff, "activateAccountByPIN");
      return await req(data);
    } catch (error) {
      console.error("Error to activateCard:", error);
      this.alertService
        .showAlert(ALERT_TYPE.ERROR, JSON.stringify(error))
        .then();
      throw error;
    }
  }

  /**
   * Método que transforma o nome do usuário como "Steve Jobs"
   * em 2 campos, primeiro nome e último nome e retorna um
   * objeto como resultado.
   * @param {string} userName nome do usuário
   * @return {firstName: string, lastName: string} objeto com
   * nome e sobrenome do usuário.
   */
  sortUserName(userName: string): { firstName: string; lastName: string } {
    const nameArr = userName.split(" ");
    const name = {
      firstName: nameArr[0],
      lastName: nameArr.slice(1).join(" "),
    };
    return name;
  }
}
